import { apiUrl } from '../utils/apiBase';
import { quickBooksAuthHeaders } from '../utils/quickBooksAuth';

/**
 * Current user's Xero connection for the given org (GET /api/xero/status).
 */
export async function fetchXeroStatus(orgId) {
  if (!orgId) {
    return { connected: false, tenant_id: null, tenant_name: null, updated_at: null, error: '' };
  }

  const auth = await quickBooksAuthHeaders();
  const res = await fetch(apiUrl(`/api/xero/status?org_id=${encodeURIComponent(orgId)}`), {
    credentials: 'include',
    headers: { ...auth },
  });
  const text = await res.text();
  let data = {};
  try {
    data = text ? JSON.parse(text) : {};
  } catch {
    data = {};
  }
  if (!res.ok) {
    const message =
      data.error ||
      (text && !text.startsWith('{') ? text.slice(0, 200).trim() : '') ||
      `Could not load Xero status (HTTP ${res.status}). Is the API server running on port 5001?`;
    throw new Error(message);
  }
  return {
    connected: !!data.connected,
    tenant_id: data.tenant_id ?? null,
    tenant_name: data.tenant_name ?? null,
    updated_at: data.updated_at ?? null,
    error: data.error || '',
  };
}
